// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"fad649a6","456":"2d474068","656":"62a5d230","756":"f357c94b","968":"2d8b226e"}[chunkId] + ".chunk.js";
};